
export const pins = {
  data () {
    return {
      pin: null
    }
  },
  computed: {
    number () {
      if (!this.pin) return ''
      const idx = this.pin.id.indexOf('_')
      const id = this.pin.id.substr(idx + 1)
      return id.length < 2 ? '0' + id : id
    },
    pincode () {
      if (!this.pin) return ''
      const code = this.pin.code
      return code.type + '-' + code.name + '-' + this.number + '-'
    },
    namecode () {
      if (!this.pin) return ''
      const code = this.pin.code
      return code.name + '-' + this.number
    }
  },
  methods: {
    setPindata (data) {
      this.pin = data
    }
  }
}
